import React from "react";

const ArrowRedBottomIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_849_4142"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect
          x="24"
          y="24"
          width="24"
          height="24"
          transform="rotate(-180 24 24)"
          fill="#D9D9D9"
        />
      </mask>
      <g mask="url(#mask0_849_4142)">
        <path
          d="M12.9992 15.2L15.8992 12.3C16.0826 12.1166 16.3159 12.025 16.5992 12.025C16.8826 12.025 17.1159 12.1166 17.2992 12.3C17.4826 12.4833 17.5742 12.7166 17.5742 13C17.5742 13.2833 17.4826 13.5166 17.2992 13.7L12.6992 18.3C12.4992 18.5 12.2659 18.6 11.9992 18.6C11.7326 18.6 11.4992 18.5 11.2992 18.3L6.69922 13.7C6.51589 13.5166 6.42422 13.2833 6.42422 13C6.42422 12.7166 6.51589 12.4833 6.69922 12.3C6.88255 12.1166 7.11589 12.025 7.39922 12.025C7.68255 12.025 7.91589 12.1166 8.09922 12.3L10.9992 15.2L10.9992 6.99997C10.9992 6.71664 11.0951 6.47914 11.2867 6.28748C11.4784 6.09581 11.7159 5.99997 11.9992 5.99997C12.2826 5.99997 12.5201 6.09581 12.7117 6.28748C12.9034 6.47914 12.9992 6.71664 12.9992 6.99997L12.9992 15.2Z"
          fill="#C71A1A"
        />
      </g>
    </svg>
  );
};

export default ArrowRedBottomIcon;
